module finadai.config {
  export var NAME = "finadai.config";

  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider, $locationProvider: ng.ILocationProvider) {
   // if(window.location.host != 'finadaiapp.app')
      //$locationProvider.html5Mode(false);
    // For unmatched routes
    $urlRouterProvider.otherwise('/');

    // Application routes
    $stateProvider
      .state('app', {
        abstract: true,
        controller: 'AppController',
        templateUrl: 'app/app.tpl.html',
        resolve: {
          whoIAm: function(authService: finadai.services.AuthService){
            return authService.isLoggedIn();
          }
        }
      })
      .state('app.dashboard', {
        url: '/',
        templateUrl: 'app/dashboard/dashboard.tpl.html',
        controller: 'DashboardController'
      })
      .state('app.map', {
        url: '/map',
        template: '<iframe src="http://map.quam.mx" width="100%" height="700"></iframe>'
      })
      .state('app.notFound', {
        // url: '/notFound',
        templateUrl: 'app/layout/404.tpl.html',
        onEnter: ($rootScope) => {
          $rootScope.$broadcast('searchOveraly:close');
        }
      })
      .state('app.changePassword',{
        templateUrl: "app/changePassword/changePasswordLoggedIn.tpl.html",
        url: "/changePassword",
        controller: "ChangePasswordController"
      })
      .state('register', {
        templateUrl: "app/register/register.tpl.php",
        url: "/registro",
        controller: "RegisterController",
        params: {
            name: null,
            rfc: null,
            last_name: null,
            customer_number: null,
            hiddenParam: 'YES',
        }
      })
      .state('registerSuccess', {
        templateUrl: "app/register/registerSuccess.tpl.php",
        url: "/registroExito",
      })
      .state('findYourCredit', {
        templateUrl: "app/findYourCredit/findYourCredit.tpl.html",
        url: "/findYourCredit",
        controller: "FindYourCreditController",
        resolve: {
        }
      })
      .state('login', {
        templateUrl: "app/login/login.tpl.html",
        url: "/login/:token?send_to&cn&gi",
        controller: "LoginController",
        resolve: {
            tokenAccess: () => null,
            tokenConfirm: (customersService: services.CustomersService, $stateParams) => {
            if(angular.isDefined($stateParams.token) && $stateParams.token != ''){
              return customersService.proxyValidate($stateParams.token);
            }
            return null;
          }
        }
      })
      .state('validateAccount', {
          templateUrl: "app/login/validate.tpl.html",
          url: "/validate_account/:token?send_to&cn&gi",
          controller: "LoginController",
          resolve: {
              tokenAccess: () => null,
              tokenConfirm: (customersService: services.CustomersService, $stateParams) => {
                  if(angular.isDefined($stateParams.token) && $stateParams.token != ''){
                      return customersService.proxyValidate($stateParams.token);
                  }
                  return null;
              }
          }
      })
      .state('accessAccount', {
            templateUrl: "app/login/access.tpl.html",
            url: "/due_negotiation/:token?send_to&cn&gi",
            controller: "LoginController",
            resolve: {
               tokenConfirm: () => null,
               tokenAccess: (customersService: services.CustomersService, $stateParams) => {
               if(angular.isDefined($stateParams.token) && $stateParams.token != ''){
                 return customersService.proxyAccessToken($stateParams.token);
               }
               return null;
            }
        }
      });
  }
  
  export function run() {
    var config = angular.module(NAME, [
      'ui.router',
    ]);
    config.run(($rootScope, $state: ng.ui.IStateService, authService: services.AuthService, notify) => {

      $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
        if(angular.isDefined(error.status) && error.status == 404){
          $state.go('app.notFound');
        }
        console.log("error", error);
      });
      
      $rootScope.$on('$stateChangeStart', function(event, toState: ng.ui.IState, toParams, fromState, fromParams, options){
        
        if($rootScope.stateChangeBypass) {
          $rootScope.stateChangeBypass = false;
          return;
        }

        event.preventDefault();
        
        if(!authService.isWhiteListStates(toState.name)){
          authService.isLoggedIn().then(response => {
            $rootScope.stateChangeBypass = true;
            if(response.states.filter(item => item == toState.name).length == 0){
              console.log('State to not authorized:', toState.name)
              notify('Acceso no autorizado', 'danger');
              $state.go('app.dashboard');
            }
            else{
              $state.go(toState, toParams);
            }
          }, responseError => {
            $rootScope.stateChangeBypass = true;
          });
        }
        else{
          $rootScope.stateChangeBypass = true;
          $state.go(toState, toParams);
        }
      });
      $rootScope.$on('$stateChangeSuccess', function(event, toState: ng.ui.IState, toParams, fromState, fromParams){
        $("input").blur();
        if(angular.isDefined(window.ga) && angular.isDefined(toState.url)){
          window.ga('set', 'page', toState.url);
          window.ga('send', 'pageview');
        }
      });
      
    })
    config.config(ConfigRoutes);
    config.config(function($ocLazyLoadProvider) {
      $ocLazyLoadProvider.config({
        debug: false,
        events: false
      });
    });
  }
}
finadai.config.run();